import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getSchemaBySlug } from '../engine/registry';
import { fetchResult } from '../engine/persistence';
import { matchArchetype } from '../engine/archetype';
import { trackEvent } from '../engine/analytics';
import type { ScoredResult } from '../engine/types';
import NotFound from './NotFound';

export default function AssessmentResult() {
  const { slug = '', uuid = '' } = useParams();
  const schema = getSchemaBySlug(slug);
  const [result, setResult] = useState<ScoredResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!schema) return;
    fetchResult(schema.id, uuid)
      .then((r) => {
        if (!r.archetype && schema.id === 'board-ai-literacy' && typeof r.score === 'object') {
          const axes = r.score as Record<string, number>;
          r.archetype = matchArchetype(
            { gov: axes.governance ?? 0, cap: axes.capability ?? 0 },
            { lowConfidence: (r.coverageFlags?.length ?? 0) > 0 },
          );
        }
        setResult(r);
        if (schema) {
          trackEvent(`${schema.analytics.eventPrefix}_result_viewed`, {
            schema_id: schema.id,
            uuid,
            band: r.band,
            score: r.composite ?? r.score,
          });
        }
      })
      .catch((e) => setError((e as Error).message));
  }, [schema, uuid]);

  if (!schema) return <NotFound />;
  if (error) return <p className="text-danger">{error}</p>;
  if (!result) return <p>Loading your result…</p>;

  const ResultComponent = schema.results.component;
  return <ResultComponent result={result} intake={result.intake} />;
}
